import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/home/runner/work/pos-ui/pos-ui/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContainer"] */ "/home/runner/work/pos-ui/pos-ui/components/LayoutWrapper/style.ts");
